// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePickerHeaderForPurchaseOrders_root__3Cr6V","select":"DatePickerHeaderForPurchaseOrders_select__9PUlI"};